/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostSsoResolveRequest
 */
export interface PostSsoResolveRequest {
    /**
     * 
     * @type {string}
     * @memberof PostSsoResolveRequest
     */
    challenge_id: string;
    /**
     * 
     * @type {string}
     * @memberof PostSsoResolveRequest
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof PostSsoResolveRequest
     */
    pkce_code_verifier: string;
}

/**
 * Check if a given object implements the PostSsoResolveRequest interface.
 */
export function instanceOfPostSsoResolveRequest(value: object): value is PostSsoResolveRequest {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('pkce_code_verifier' in value) || value['pkce_code_verifier'] === undefined) return false;
    return true;
}

export function PostSsoResolveRequestFromJSON(json: any): PostSsoResolveRequest {
    return PostSsoResolveRequestFromJSONTyped(json, false);
}

export function PostSsoResolveRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostSsoResolveRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'code': json['code'],
        'pkce_code_verifier': json['pkce_code_verifier'],
    };
}

export function PostSsoResolveRequestToJSON(json: any): PostSsoResolveRequest {
    return PostSsoResolveRequestToJSONTyped(json, false);
}

export function PostSsoResolveRequestToJSONTyped(value?: PostSsoResolveRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge_id': value['challenge_id'],
        'code': value['code'],
        'pkce_code_verifier': value['pkce_code_verifier'],
    };
}

